import styled from '@emotion/styled'

export const IconWrapper = styled.div`
    height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
`
